import { createAction } from '@reduxjs/toolkit';
import { RemoteConfig, ConversationChangedEventData } from './interfaces';

export const remoteConfigFetched = createAction<RemoteConfig>('app/remoteConfigFetched');

export const receiveMessageReplied = createAction<ConversationChangedEventData>(
  'app/receiveMessageReplied'
);
